import axios from 'axios';

// Gemini AI API configuration
const API_KEY = 'AIzaSyCIRoRhAN7Q-jtnwhRZMyzs55X6hT4Sj7Y';
const API_ENDPOINT =
  'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent';

if (!API_KEY) {
  console.warn(
    'No API key found for Gemini AI. The chatbot will fall back to rule-based responses.'
  );
}

/**
 * Generates a response from Gemini AI based on the user's message and conversation history
 * @param message The user's message
 * @param conversationHistory Previous messages in the conversation for context
 * @returns The AI-generated response
 */
export async function generateGeminiResponse(
  message: string,
  conversationHistory: string[] = []
): Promise<string> {
  if (!API_KEY) {
    return 'I apologize, but I cannot process your request at the moment. Please try again later or contact support.';
  }

  try {
    // Format conversation history for the API
    const formattedHistory = conversationHistory.map((msg, index) => ({
      role: index % 2 === 0 ? 'user' : 'model',
      parts: [{ text: msg }],
    }));

    // Add the current message with "owenscorning" prepended
    const enhancedMessage = `owenscorning ${message}`;
    const contents = [
      ...formattedHistory,
      {
        role: 'user',
        parts: [{ text: enhancedMessage }],
      },
    ];

    // Make the API request
    const response = await axios.post(`${API_ENDPOINT}?key=${API_KEY}`, {
      contents,
      generationConfig: {
        temperature: 0.7,
        topK: 40,
        topP: 0.95,
        maxOutputTokens: 1024,
      },
      safetySettings: [
        {
          category: 'HARM_CATEGORY_HARASSMENT',
          threshold: 'BLOCK_MEDIUM_AND_ABOVE',
        },
        {
          category: 'HARM_CATEGORY_HATE_SPEECH',
          threshold: 'BLOCK_MEDIUM_AND_ABOVE',
        },
        {
          category: 'HARM_CATEGORY_SEXUALLY_EXPLICIT',
          threshold: 'BLOCK_MEDIUM_AND_ABOVE',
        },
        {
          category: 'HARM_CATEGORY_DANGEROUS_CONTENT',
          threshold: 'BLOCK_MEDIUM_AND_ABOVE',
        },
      ],
    });

    // Extract and return the generated text
    if (response.data.candidates && response.data.candidates.length > 0) {
      const candidate = response.data.candidates[0];
      if (
        candidate.content &&
        candidate.content.parts &&
        candidate.content.parts.length > 0
      ) {
        return candidate.content.parts[0].text;
      }
    }

    throw new Error('No valid response from Gemini AI');
  } catch (error) {
    console.error('Error generating response from Gemini AI:', error);
    return 'I apologize, but I encountered an error processing your request. Please try again later.';
  }
}
